/**
 * Thin wrapper around the Telegram WebApp SDK loaded from telegram.org in index.html.
 * All admin requests carry `initData` in a custom header; the server verifies the HMAC.
 */

export interface TgUser {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
}

export interface TelegramWebApp {
  initData: string;
  initDataUnsafe: { user?: TgUser; start_param?: string };
  ready(): void;
  expand(): void;
  close(): void;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  openTelegramLink?(url: string): void;
  shareMessage?(msg_id: string, cb?: (ok: boolean) => void): void;
  showPopup?(params: { title?: string; message: string; buttons?: any[] }): void;
  HapticFeedback?: { notificationOccurred(type: 'error' | 'success' | 'warning'): void };
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function getTg(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function getInitData(): string {
  return getTg()?.initData ?? '';
}

export function getTgUser(): TgUser | null {
  return getTg()?.initDataUnsafe.user ?? null;
}

export function initTelegram(): void {
  const tg = getTg();
  if (!tg) return;
  try {
    tg.ready();
    tg.expand();
  } catch {
    // SDK may not be fully available in some embedders
  }
}

export function isInsideTelegram(): boolean {
  return !!getTg()?.initData;
}
